import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './options/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { ForgotpasswordComponent } from './components/forgotpassword/forgotpassword.component';
import { RegisterUserComponent } from './components/register-user/register-user.component';
import { SettingsComponent } from './options/settings/settings.component';
import { AuthGuard } from './services/authservice/authguard';
import { AgenciesComponent } from "./options/agencies/agencies.component";
import { RequestsComponent } from "./options/requests/requests.component";
import { CasesComponent } from "./options/cases/cases.component";

export let routes: Routes = [
	{ path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
	{ path: 'login', component: LoginComponent },
	{ path: 'recovery', component: ForgotpasswordComponent },
	{ path: 'user-registration/:token', component: RegisterUserComponent },
	{ path: 'requests', component: RequestsComponent, canActivate: [AuthGuard], data: { title: 'Requests' } },
	{ path: 'cases', component: CasesComponent, canActivate: [AuthGuard], data: { title: 'Cases' } },
	{ path: 'agencies', component: AgenciesComponent, canActivate: [AuthGuard], data: { title: 'Agencies' } },
	{ path: 'settings', component: SettingsComponent, canActivate: [AuthGuard], data: { title: 'Settings' } },
	{ path: '', redirectTo: '/home', pathMatch: 'full' },
	{ path: '**', redirectTo: '/home', pathMatch: 'full' }
];

export const AppRoutingModule = RouterModule.forRoot(routes, {});
